import {Component, EventEmitter, Input, OnDestroy, OnInit, Optional, Output} from "@angular/core";
import {FUIStackedPageContextService} from "@fedelta-pos/ui";
import {Subscription} from "rxjs";

/**
 *
 */
@Component({
    selector: "fhm-page",
    templateUrl: "./page.component.html",
    styleUrls: ["./page.component.scss"],
    standalone: false
})
export class PageComponent implements OnInit, OnDestroy {

    @Output() changeTimeSelection: EventEmitter<string> = new EventEmitter<string>();
    @Output() serviceSelection: EventEmitter<string> = new EventEmitter<string>();
    @Output() nameSearchChanged: EventEmitter<string> = new EventEmitter<string>();

    @Output() resetTimeRange: EventEmitter<any> = new EventEmitter<any>();
    @Output() doneClicked: EventEmitter<any> = new EventEmitter<any>();
    @Output() saveClicked: EventEmitter<any> = new EventEmitter<any>();
    @Output() completeClicked: EventEmitter<any> = new EventEmitter<any>();

    @Input() title: string;
    @Input() description: string;

    @Input() showColumnSearch: boolean;

    @Input() showDone: boolean = false;
    @Input() showSave: boolean = false;
    @Input() saveLabel: string = "fhm.common.button.save";
    @Input() showComplete: boolean = false;
    @Input() completeLabel: string = "fhm.common.button.complete";


    public service: string;
    nameSearch: string;

    private subscriptions: Subscription = new Subscription();

    constructor(@Optional() public stackedPageContextService: FUIStackedPageContextService) {

        if (stackedPageContextService) {
            this.subscriptions.add(this.stackedPageContextService.onCloseRequest.subscribe((closeConfirmation) => {
                closeConfirmation.canClose = true;
            }));
        }
    }

    ngOnInit(): void {
        if (this.stackedPageContextService) {
            this.description = undefined;
        }
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    clearFilter(): void {
        this.nameSearch = undefined;
    }
}
